<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '600px' }"
  [baseZIndex]="2300000"
  styleClass="create-tag-dialog"
  (onHide)="close()"
>
  <ng-template pTemplate="header">
    <div class="dialog-header">
      <div class="dialog-title">
        <i class="pi pi-plus-circle dialog-icon"></i>
        <div class="title-content">
          <h2>Nuovo Tag</h2>
          <p class="title-subtitle">Crea un nuovo tag</p>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="dialog-content">
 <!--    <p-card styleClass="form-card"> -->
      <div class="form-container">
        <!-- Selezione Categoria -->
        <div class="form-field">
          <label for="categoriaSelect">
            Categoria <span class="required">*</span>
          </label>
          <p-dropdown
            id="categoriaSelect"
            [options]="categories"
            [(ngModel)]="newTagCategory"
            optionLabel="name"
            optionValue="code"
            placeholder="Seleziona una categoria"
            [style]="{ width: '100%' }"
            [showClear]="true"
            [appendTo]="'body'"
            [overlayOptions]="{ baseZIndex: 2200000 }"
            (onChange)="checkCodiceDuplicato()"
            (onShow)="onCategoryDropdownToggle($event)"
            (onHide)="onCategoryDropdownToggle($event)"
          >
            <ng-template let-category pTemplate="item">
              <div class="category-dropdown-item">
                <span class="material-symbols-outlined category-icon">{{ getCategoryIcon(category.code) }}</span>
                <span class="category-name">{{ category.name }}</span>
              </div>
            </ng-template>
            <ng-template let-category pTemplate="selectedItem">
              <div class="category-selected-item">
                <span class="material-symbols-outlined category-icon-selected">{{ getCategoryIcon(category.code) }}</span>
                <span class="category-name-selected">{{ category.name }}</span>
              </div>
            </ng-template>
          </p-dropdown>
        </div>

        <!-- Inserimento Codice -->
        <div class="form-field" *ngIf="newTagCategory">
          <label for="codiceInput">
            Codice <span class="required">*</span>
          </label>
          <span class="p-input-icon-left p-input-icon-right" style="width: 100%;">
            <i class="pi pi-tag"></i>
            <input
              id="codiceInput"
              type="text"
              pInputText
              [(ngModel)]="newTagCodice"
              (input)="checkCodiceDuplicato()"
              placeholder="Inserisci il codice del tag"
              [class.p-invalid]="codiceDuplicato"
              [style]="{ width: '100%' }"
            />
            <i class="pi pi-check" *ngIf="newTagCodice.trim() && !codiceDuplicato" style="color: green;"></i>
            <i class="pi pi-times" *ngIf="codiceDuplicato" style="color: red;"></i>
          </span>
          <small class="p-error" *ngIf="codiceDuplicato">
            Questo codice è già presente nella categoria selezionata
          </small>
          <small class="p-help-text" *ngIf="!codiceDuplicato && newTagCodice.trim()">
            Codice disponibile
          </small>
        </div>
      </div>
   <!--  </p-card> -->
  </div>

  <ng-template pTemplate="footer">
    <div class="dialog-footer">
      <button
        pButton
        type="button"
        label="Annulla"
        icon="pi pi-times"
        class="p-button-text"
        (click)="close()"
        [disabled]="savingTag"
      ></button>
      <button
        pButton
        type="button"
        label="Salva"
        icon="pi pi-check"
        [disabled]="!isFormValid() || savingTag"
        [loading]="savingTag"
        (click)="save()"
      ></button>
    </div>
  </ng-template>
</p-dialog>


